export const LegalSlugs = {
    imprint: 'impressum',
    privacy: 'datenschutz',
    legal: 'rechtliche-hinweise',
} as const;

export function getImprintUrl(dealerSlug: string): string {
    return `/${dealerSlug}/${LegalSlugs.imprint}`;
}

export function getPrivacyUrl(dealerSlug: string): string {
    return `/${dealerSlug}/${LegalSlugs.privacy}`;
}

export function getLegalUrl(dealerSlug: string): string {
    return `/${dealerSlug}/${LegalSlugs.legal}`;
}

export function getGlobalImprintUrl(): string {
    return 'https://www.hyundai.com/de/de/impressum.html';
}

export function getGlobalPrivacyUrl(): string {
    return 'https://www.hyundai.com/de/de/datenschutz.html';
}

export function getGlobalLegalUrl(): string {
    return 'https://www.hyundai.com/de/de/legal-disclaimer.html';
}
